import { products } from '../data/milestones'
import HealthOrb from './HealthOrb'
import { useAuth } from '../context/AuthContext'

const navItems = [
  { key: 'all', label: 'الكل', icon: '◈', product: null },
  { key: 'rafiq', label: 'رفيق', icon: '🚗', product: 'rafiq' },
  { key: 'muwafaq', label: 'موافق', icon: '✅', product: 'muwafaq' },
  { key: 'sahha', label: 'صحة', icon: '🏥', product: 'sahha' },
  { key: 'labor', label: 'بوابة العمالة', icon: '👷', product: 'labor' },
  { key: 'dashboard', label: 'لوحة التحكم', icon: '📊', product: 'dashboard' },
  { key: 'infra', label: 'بنية تحتية', icon: '🏗️', product: 'infra' },
  { key: 'operations', label: 'العمليات', icon: '🦅', product: null },
]

export default function Sidebar({ activeProduct, onNavigate, healthData, isOpen, onClose }) {
  const { logout } = useAuth()

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/60 backdrop-blur-sm lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed top-0 right-0 bottom-0 z-40
        w-60 bg-base border-l border-white/[0.06]
        flex flex-col
        transition-transform duration-250 ease-out
        lg:translate-x-0
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}
      `}>
        {/* Logo */}
        <div className="p-5 border-b border-white/[0.06]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-surface border border-white/[0.06] flex items-center justify-center text-lg font-bold text-[#8B5CF6]">
              س
            </div>
            <div>
              <h1 className="text-sm font-bold text-[#F1F5F9]">سناجم</h1>
              <p className="text-[10px] text-[#475569] font-medium">مركز القيادة</p>
            </div>
          </div>
        </div>

        {/* Nav items */}
        <nav className="flex-1 py-4 px-3 overflow-y-auto">
          <p className="text-[10px] font-semibold text-[#475569] tracking-wider uppercase px-4 mb-2">المشاريع</p>

          {navItems.map(item => {
            const isActive = activeProduct === item.key
            const prodConfig = item.product ? products[item.product] : null
            const healthStatus = item.product && healthData?.[item.product]
              ? healthData[item.product].status
              : null

            return (
              <button
                key={item.key}
                onClick={() => {
                  onNavigate(item.key)
                  onClose?.()
                }}
                className={`
                  w-full flex items-center gap-3 px-4 py-3 text-sm transition-all duration-150 mb-1
                  ${isActive
                    ? `bg-white/[0.06] text-[#F1F5F9] border-r-2 rounded-l-[10px] rounded-r-none`
                    : 'text-[#94A3B8] hover:bg-white/[0.03] hover:text-[#F1F5F9] rounded-[10px]'
                  }
                `}
                style={isActive && prodConfig ? { borderRightColor: prodConfig.primary } : {}}
              >
                <span className="text-base">{item.icon}</span>
                <span className="flex-1 text-right font-medium">{item.label}</span>
                {healthStatus && (
                  <HealthOrb
                    status={healthStatus}
                    size="sm"
                    ariaLabel={`${item.label}: ${healthStatus === 'healthy' ? 'يعمل' : healthStatus === 'degraded' ? 'بطيء' : 'متوقف'}`}
                  />
                )}
              </button>
            )
          })}
        </nav>

        {/* Footer */}
        <div className="p-3 border-t border-white/[0.06]">
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-[#64748B] hover:text-red-400 hover:bg-red-500/[0.06] rounded-[10px] transition-all duration-150"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className="font-medium">تسجيل الخروج</span>
          </button>
          <p className="text-[10px] text-[#475569] text-center mt-2">© 2026 Sanajim</p>
        </div>
      </aside>
    </>
  )
}
